import "../App.css";

function MoreAbout() {
  return (
    <div>
      <section className="text-gray-600 body-font bg-[#990000] ">
        <div className="container mx-auto flex px-5 py-20 md:flex-row flex-col items-center mobile__about md:mt-[-64px]">
          <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 ">
            {/*<span> KNOW MORE ABOUT</span> 
MAYO COLLEGE GIRLS’ SCHOOL */}
            <h1 className="title-font sm:text-xl text-[20px] md:text-4xl mb-4 font-bold text-left mb-3">
              <span className="text-white">S.G.N DOON VALE SCHOOL</span>

              <br className=" lg:inline-block" />
              <span className="text-[#03001B]"> KNOW MORE ABOUT</span>
            </h1>
            <div className="flex items-center mb-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-9 h-9 text-yellow-400"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="256px"
                height="256px"
                viewBox="0 0 32 32"
              >
                <defs>
                  <linearGradient id="grad1">
                    <stop offset="100%" stop-color="#ffaa00" />
                    <stop offset="50%" stop-color="grey" />
                  </linearGradient>
                </defs>
                <path
                  fill="url(#grad1)"
                  d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118
  l11.547-1.2L16.026,0.6L20.388,10.918z"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-9 h-9 text-yellow-400 mx-1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="256px"
                height="256px"
                viewBox="0 0 32 32"
              >
                <defs>
                  <linearGradient id="grad2">
                    <stop offset="100%" stop-color="#ffaa00" />
                    <stop offset="50%" stop-color="grey" />
                  </linearGradient>
                </defs>
                <path
                  fill="url(#grad2)"
                  d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118
  l11.547-1.2L16.026,0.6L20.388,10.918z"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-9 h-9 text-yellow-400 mx-1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="256px"
                height="256px"
                viewBox="0 0 32 32"
              >
                <defs>
                  <linearGradient id="grad3">
                    <stop offset="100%" stop-color="#ffaa00" />
                    <stop offset="50%" stop-color="grey" />
                  </linearGradient>
                </defs>
                <path
                  fill="url(#grad3)"
                  d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118
  l11.547-1.2L16.026,0.6L20.388,10.918z"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-9 h-9 text-yellow-400 mx-1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="256px"
                height="256px"
                viewBox="0 0 32 32"
              >
                <defs>
                  <linearGradient id="grad3">
                    <stop offset="100%" stop-color="#ffaa00" />
                    <stop offset="50%" stop-color="grey" />
                  </linearGradient>
                </defs>
                <path
                  fill="url(#grad3)"
                  d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118
  l11.547-1.2L16.026,0.6L20.388,10.918z"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-9 h-9 text-yellow-400 mx-1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="256px"
                height="256px"
                viewBox="0 0 32 32"
              >
                <defs>
                  <linearGradient id="grad">
                    <stop offset="50%" stop-color="#ffaa00" />
                    <stop offset="50%" stop-color="white" />
                  </linearGradient>
                </defs>
                <path
                  fill="url(#grad)"
                  d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118
  l11.547-1.2L16.026,0.6L20.388,10.918z"
                />
              </svg>

              <p className="ml-2 text-lg font-medium text-white ">
                166 reviews
              </p>
            </div>
            <p className="mb-8 leading-relaxed text-white  text-justify">
              Welcome to Shri Guru Nanak Doon Vale School, one of the most
              trusted and respected co-educational schools in Dehradun since
              1993. With a legacy of academic excellence and holistic
              development, we are dedicated to nurturing confident, responsible,
              and well-rounded individuals. Our school offers structured
              education from Nursery to Class X, blending modern teaching
              methods with strong values and discipline. At S.G.N. Doon Vale,
              learning goes beyond the classroom, with a focus on creativity,
              leadership, and moral growth. Students thrive in a safe and
              inclusive environment, supported by experienced educators and a
              vibrant house system that encourages healthy competition and
              teamwork. From engaging classroom sessions to enriching cultural
              activities, we ensure every child gets opportunities to grow and
              shine. Located in the heart of the city, we are committed to
              providing quality education at accessible standards. If you're
              searching for the best school in Dehradun, we welcome you to visit
              our campus and experience the difference. Building bright futures,
              one student at a time.
            </p>
            <div className="md:flex md:justify-center  ">
              {/* <button className=" image1  text-white bg-[#FFA700] border-0 py-2 px-6 focus:outline-none  rounded text-lg">
                Read More
              </button> */}
              <img
                className=" image2 moreabout object-cover object-center rounded"
                alt="hero"
                src="img/school_Vertical_2.JPG"
              />
            </div>
          </div>
          <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 ">
            <img
              className=" image1 moreabout object-cover object-center rounded"
              alt="hero"
              src="img/school_Vertical_2.JPG"
            />
            {/* <button className=" image2 relative right-[24px] text-white bg-[#FFA700] border-0 py-2 px-6 focus:outline-none  rounded text-lg">
              Read More
            </button> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default MoreAbout;
